import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Button from '../button';
import IntegrationBack from './integration-back';
import Input from '../input';
import TStore from '../../types/store';
import { ModalTitleSC, ModalCopySC } from '../modal/modal.styled';
import { TCurrentUser } from '../../types/users';
import { copyToClipboard } from '../../helpers/utils-helpers';

type TProps = {
  onBack(): void;
  onDone(): void;
  onHelp(): void;
};

const IntegrationCode: React.FC<TProps> = ({ onBack, onDone, onHelp }) => {
  const currentUser: TCurrentUser | null = useSelector((store: TStore) => store.users.currentUser);
  const regCode = currentUser?.registerCode || '';

  return (
    <div>
      <IntegrationBack onClick={onBack} />
      <ModalTitleSC>
        <FormattedMessage id="integration.code_step.title" />
      </ModalTitleSC>
      <ModalCopySC>
        <FormattedMessage id="integration.code_step.copy" />
      </ModalCopySC>

      <div className="input-with-btn">
        <Input
          name="code"
          value={regCode}
          onChange={() => null}
          inputStyle={{
            fontSize: 24,
            fontWeight: 'bold',
          }}
        />
        <span className="copy-label" onClick={() => copyToClipboard(regCode)}>
          <FormattedMessage id="integration.code_step.copy_code" />
        </span>
      </div>

      <span className="help-link" onClick={onHelp}>
        <FormattedMessage id="integration.code_step.help_link" />
      </span>
      <Button isBlock kind="PRIMARY" onClick={onDone}>
        <FormattedMessage id="integration.done" />
      </Button>
    </div>
  );
};

export default IntegrationCode;
